export const ORDER_CODE = 'orderCode';
export const GOOGLE_RECAPTCHA_SITE_KEY = '6LcUlrspAAAAAJvWNR0AFR0QdcK9nSmyOvlwt_8h';
